import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout.tsx";
import Dashboard from "../app/dashboard/views/Dashboard.tsx";
import Item from "../app/data_management/views/Item.tsx";
import ItemDetail from "../app/data_management/views/ItemDetails.tsx";
import Office from "../app/data_management/views/Office.tsx";
import Vendor from "../app/data_management/views/Vendor.tsx";
import Employee from "../app/data_management/views/Employee.tsx";
import Attendance from "../app/data_management/views/Attendance.tsx";
import Role from "../app/role/views/Role.tsx";
import UserProfile from "../app/user_profile/views/UserProfile.tsx";
import Change from "../app/user_profile/views/ChangePassword.tsx";
import AHS from "../app/sales/views/AHS.tsx";
import Project from "../app/sales/views/ProjectListing.tsx";
import RAB from "../app/sales/views/RAB.tsx";
import Bidding from "../app/sales/views/BiddingProcess.tsx";
import Payroll from "../app/building_management/views/Payroll.tsx";
import ProjectDetail from "../app/building_management/views/ProjectDetail.tsx";
import BuildingRepair from "../app/building_management/views/BuildingRepair.tsx";
import BuildingAssessment from "../app/building_management/views/BuildingAssessment.tsx";
import RABBuilding from "../app/building_management/views/RAB.tsx";
import RABMonitoring from "../app/building_management/views/RABMonitoring.tsx";
import Inventory from "../app/building_management/views/Inventory.tsx";
// import WorkspaceReadiness from "../app/building_management/views/WorkspaceReadiness.tsx";
import LelangKontrak from "../app/project_management/views/LelangProcess.tsx";
import Workspace from "../app/building_management/views/Workspace.tsx";
import BuildingSurvey from "../app/building_management/views/BuildingSurvey.tsx";
import RAP from "../app/project_management/views/RAP.tsx";
import RollingForecast from "../app/project_management/views/RollingForecast.tsx";
import ProjectManagementReport from "../app/project_management/views/ProjectManagementReport.tsx";

const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

const ProtectedRoute = () => {
  const userData = JSON.parse(localStorage.getItem("user") || "null");
  return isAuthenticated() ? (
    <Routes>
      <Route path="/" element={<AdminLayout><Dashboard /></AdminLayout>} />
      <Route path="/data-management/item" element={<AdminLayout><Item /></AdminLayout>} />
      <Route path="/data-management/item-detail" element={<AdminLayout><ItemDetail /></AdminLayout>} />
      <Route path="/data-management/office" element={<AdminLayout><Office /></AdminLayout>} />
      <Route path="/data-management/vendor" element={<AdminLayout><Vendor /></AdminLayout>} />
      <Route path="/data-management/employee" element={<AdminLayout><Employee /></AdminLayout>} />
      <Route path="/data-management/attendance" element={<AdminLayout><Attendance /></AdminLayout>} />
      <Route path="/role" element={<AdminLayout><Role /></AdminLayout>} />
      <Route path="/user-profile" element={<AdminLayout><UserProfile user={userData}/></AdminLayout>} />
      <Route path="/change-password" element={<AdminLayout><Change /></AdminLayout>} />
      <Route path="/sales/ahs" element={<AdminLayout><AHS /></AdminLayout>} />
      <Route path="/sales/project" element={<AdminLayout><Project /></AdminLayout>} />
      <Route path="/sales/rab" element={<AdminLayout><RAB /></AdminLayout>} />
      <Route path="/sales/bidding" element={<AdminLayout><Bidding /></AdminLayout>} />
      <Route path="/building-management/payroll" element={<AdminLayout><Payroll /></AdminLayout>} />
      <Route path="/building-management/project-detail" element={<AdminLayout><ProjectDetail /></AdminLayout>} />
      <Route path="/building-management/repair" element={<AdminLayout><BuildingRepair user={userData}/></AdminLayout>} />
      <Route path="/building-management/rab" element={<AdminLayout><RABBuilding /></AdminLayout>} />
      <Route path="/building-management/rab-absorption" element={<AdminLayout><RABMonitoring /></AdminLayout>} />
      <Route path="/building-management/inventory" element={<AdminLayout><Inventory /></AdminLayout>} />
      <Route path="/building-management/building-assessment" element={<AdminLayout><BuildingAssessment /></AdminLayout>} />
      {/* <Route path="/building-management/workspace-readiness" element={<AdminLayout><WorkspaceReadiness /></AdminLayout>} /> */}

      <Route path="/building-management/workspace" element={<AdminLayout><Workspace /></AdminLayout>} />
      <Route path="/building-management/survey" element={<AdminLayout><BuildingSurvey /></AdminLayout>} />
      <Route path="/project-management/lelang" element={<AdminLayout><LelangKontrak /></AdminLayout>} />
      <Route path="/project-management/rap" element={<AdminLayout><RAP /></AdminLayout>} />
      <Route path="/project-management/rolling-forecast" element={<AdminLayout><RollingForecast /></AdminLayout>} />
      <Route path="/project-management/project-management-report" element={<AdminLayout><ProjectManagementReport /></AdminLayout>} />
    </Routes>
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
